export default __webpack_public_path__ + "static/media/cert-general2024-consumer-sc.a432937e.jpg";